var map = {
	"./basic.vue": "1092",
	"./default.vue": "7b3d",
	"./defaultTinyEmail.vue": "1601",
	"./defaultWithoutSidebar.vue": "919f",
	"./defaultWithoutSidebarLogo.vue": "50ab",
	"./defaultWithoutVuePerfectScrollbar.vue": "d5149",
	"./default_old.vue": "d973",
	"./iframeLayout.vue": "8cbc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81be";